"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var azureTools_1 = __importDefault(require("./azureTools"));
var uploadStateEnum_1 = require("./uploadStateEnum");
var ApplicationError_1 = require("../ApplicationError");
var UploadManager = /** @class */ (function () {
    function UploadManager(axios, imageService, store) {
        this.imageService = imageService;
        this.store = store;
        this.azureTools = new azureTools_1.default(axios);
    }
    UploadManager.prototype.reprocess = function (fileId, systemUser) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.imageService.reprocess(fileId, systemUser)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    UploadManager.prototype.uploadFile = function (fileModel, fnUpdateModel) {
        return __awaiter(this, void 0, void 0, function () {
            var systemUser, _a, name_1, size, mimeType, infoResponse, isValid, data, err_1;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!fileModel.file) return [3 /*break*/, 7];
                        systemUser = fileModel.systemUser;
                        _a = fileModel.file, name_1 = _a.name, size = _a.size;
                        mimeType = fileModel.mimeType();
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 6, , 7]);
                        return [4 /*yield*/, this.imageService.getSharedAccessSignature(name_1, size, mimeType, 
                            // null,
                            // fileModel.projectId,
                            // fileModel.bucketId,
                            fileModel.cancelToken, systemUser)];
                    case 2:
                        infoResponse = _b.sent();
                        return [4 /*yield*/, this.azureTools.uploadToAzureInBlocks(fileModel, infoResponse.data.UploadUrl, fnUpdateModel, this.store.state.global.configs.fileUploaderMaxBlockSize, this.store.state.global.configs.fileUploaderConcurrentRequests)];
                    case 3:
                        _b.sent();
                        return [4 /*yield*/, this.imageService.verifyUploadFile(infoResponse.data.UploadId)];
                    case 4:
                        isValid = _b.sent();
                        if (!isValid) {
                            fileModel.failed();
                            return [2 /*return*/];
                        }
                        return [4 /*yield*/, this.imageService.cloudImageResize(infoResponse.data.UploadId, fileModel.file.lastModified, systemUser)];
                    case 5:
                        data = (_b.sent()).data;
                        fileModel.uploaded(infoResponse.data.UploadId, data.fileQueued, data.id, data.similarFileDetails);
                        return [3 /*break*/, 7];
                    case 6:
                        err_1 = _b.sent();
                        if (fileModel.state !== uploadStateEnum_1.FILE_STATUS.CANCELLED) {
                            if (err_1.code === ApplicationError_1.ErrorCode.HTTP_FORBIDDEN) {
                                fileModel.forbidden();
                            }
                            else {
                                fileModel.failed();
                                this.store.dispatch("alert/applicationError", err_1);
                            }
                        }
                        return [3 /*break*/, 7];
                    case 7:
                        fnUpdateModel(fileModel);
                        return [2 /*return*/];
                }
            });
        });
    };
    UploadManager.prototype.checkResizeStatus = function (idArray) {
        return __awaiter(this, void 0, void 0, function () {
            var data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.imageService.checkResizeStatus(idArray)];
                    case 1:
                        data = (_a.sent()).data;
                        return [2 /*return*/, data];
                }
            });
        });
    };
    // async setImageTags(fileIds: number[], tags: string[]) {
    //   for (let i = 0, c = tags.length; i < c; i++) {
    //     this.imageService.setImagesTag(fileIds, tags[i]);
    //   }
    // }
    // async VersionFilebyUploadId(
    //   projectId: number,
    //   imageId: number,
    //   oldImageId: number,
    // ) {
    //   await this.imageService.versionFile(projectId, imageId, oldImageId);
    // }
    UploadManager.prototype.refreshViewsByFilesIds = function (fileIds) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.imageService.refreshViewsByFilesIds(fileIds)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    return UploadManager;
}());
exports.default = UploadManager;
//# sourceMappingURL=uploadManager.js.map